(function () {
  "use strict";

  a3_cabin_reports.controller("PassengerCtrl", PassengerCtrl);

  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name PassengerCtrl
   * @description
   *  Manages the passenger information view
   * @ngInject
   */
  function PassengerCtrl(
    passenger,
    flightId,
    report,
    paxInfo,
    LuggageComplianceFactory,
    CampaignFactory,
    $scope,
    $uibModalInstance,
    $timeout,
    FlightFactory,
    CabinReportLocalEditFactory,
    CabinReportLocalEditCreatorFactory,
    UserFactory,
    WifiVouchersFactory,
    WifiAvailabilityFactory,
    SettingsMain,
    MisconnectionFlightsFactory,
    defaultCalendarDate
  ) {
    $scope.ReportIsFinal = false;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    $scope.flight = flight;
    var user = UserFactory.getUser();
    var report =
      CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);

    if (isInFinalState(flight)) $scope.ReportIsFinal = true;
    $scope.closeModal = closeModal;
    $scope.passenger = passenger;
    $scope.modalInstance = $uibModalInstance;
    $scope.getFqtvTierDescription = getFqtvTierDescription;

    initPassengerConnectionInfo();

    //upgrade passenger
    $scope.ugradePassenger = {
      showUpgradeInput: false,
      showUpgradeWarning: false,
      showUpgradeError: false,
      showSuccess: false,
      upgradedSeatNo: "",
      successMessage: "",
      upgradeRemarks: "",
    };

    $scope.submitUpgrade = submitUpgrade;
    $scope.saveUpgrade = saveUpgrade;
    $scope.undo = undo;

    //wifi scopes:
    var wifiAvailability =
      WifiAvailabilityFactory.getRegistrationsFromStorage();
    if (wifiAvailability) {
      $scope.supportsWifi = wifiAvailability.registrations.includes(
        flight.AcTailNo
      );
    } else {
      $scope.supportsWifi = false;
    }
    $scope.retrieveWifiVouchers = retrieveWifiVouchers;
    $scope.showPanel = "";
    $scope.notRetrieved = true;
    $scope.createTextVoucher = createTextVoucher;
    $scope.createStreamVoucher = createStreamVoucher;

    //Seat Change
    if (passenger.ChangedSeat) {
      $scope.passenger.IsSeatChanged = true;
    } else {
      $scope.passenger.IsSeatChanged = false;
    }
    $scope.changeSeatFormData = {
      changedSeatNo: "",
      seatChangeRemarks: "",
      showSeatChangeInput: false,
    };
    $scope.showSeatChangeWarning = false;

    /**
     * Returns a display value for Platinum when older payloads do not include a description.
     * @memberof PassengerCtrl
     * @param {object} fqtv The passenger FQTV information
     * @returns {string} The tier description shown in Passenger Details
     */
    function getFqtvTierDescription(fqtv) {
      if (!fqtv) {
        return "";
      }

      if (fqtv.TierDescription) {
        return fqtv.TierDescription;
      }

      // Platinum may arrive as a tier code only until all upstream payloads include its description.
      if (fqtv.TierLevel == "PLTM") {
        return "Platinum";
      }

      return "";
    }

    $scope.showSeatChangeError = false;
    $scope.showSeatChangeSuccess = false;
    $scope.successSeatChangeMessage = "";
    $scope.submitSeatChange = submitSeatChange;
    $scope.undoSeatChange = undoSeatChange;
    $scope.saveSeatChange = saveSeatChange;
    $scope.closeChangeWarning = closeChangeWarning;

    $scope.linkedPassengersGroup = [];
    $scope.IsOld = IsOld;
    $scope.giftStatus = CampaignFactory.giftStatusList();
    $scope.isFeedbackUpdated = false;
    $scope.submitCampaignFeedback = submitCampaignFeedback;
    $scope.hideFooter = true;
    $scope.showOneStopShop = false;

    $scope.showShopInTheCloudTab = false;
    $scope.orderAvailability = orderAvailability;

    $scope.toggleFooter = toggleFooter;
    $scope.treatmentAvailability = treatmentAvailability;

    // Cabin Luggage Report
    $scope.saEligibility = flight.LineStatus != "na";
    $scope.flightCompliant =
      LuggageComplianceFactory.getFlightCompliantStatus(flightId);
    $scope.updateCabinLuggageReport = updateCabinLuggageReport;
    var luggageReport = LuggageComplianceFactory.getPassengerLuggageCompliance(
      flightId,
      $scope.passenger.UCI
    );
    $scope.passenger.luggageCompliance = {
      hasTwoLuggage: luggageReport != null,
      isSynced: luggageReport && luggageReport.isSynced,
    };

    getlinkedPassengers();
    orderAvailability(
      passenger.FlightOrders ? passenger.FlightOrders.length : 0
    );

    function toggleFooter(hide) {
      $scope.hideFooter = hide;
    }

    /**
     * Gets called when user hits submit. Checks input then saves it
     * @memberof PassengerCtrl
     */
    function submitUpgrade() {
      $scope.ugradePassenger.showUpgradeWarning = false;
      $scope.ugradePassenger.showUpgradeError = false;
      if (!isSeatAvailableForUpgrate()) {
        return;
      }
      saveUpgrade();
    }

    /**
     * Gets called when input is ready
     * @memberof PassengerCtrl
     */
    function saveUpgrade() {
      $scope.ugradePassenger.showUpgradeWarning = false;
      $scope.ugradePassenger.showUpgradeError = false;
      updateReport();
    }

    /**
     * Checks if report is finalized
     * @memberof PassengerCtrl
     */
    function isInFinalState(flight) {
      var isInFinalState =
        flight.LineStatus === "na" ||
        flight.LineStatus === "stored" ||
        flight.LineStatus === "storedotheruser" ||
        flight.LineStatus === "stored+otheruser" ||
        flight.LineStatus === "synched" ||
        flight.LineStatus === "synchedotheruser";
      return isInFinalState;
    }

    /**
     * fix any input into 000A format
     * @memberof PassengerCtrl
     */
    function formatSeatInput() {
      var missingZeroes = 4 - $scope.ugradePassenger.upgradedSeatNo.length;
      for (var i = 0; i < missingZeroes; i++)
        $scope.ugradePassenger.upgradedSeatNo =
          "0" + $scope.ugradePassenger.upgradedSeatNo;
    }

    /**
     * Puts the new seat upgrade in the report
     * @memberof PassengerCtrl
     */
    function updateReport() {
      var upgradedPassenger = {
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        OriginalSeatNo: $scope.passenger.SeatNo,
        UpgradedSeatNo: $scope.ugradePassenger.upgradedSeatNo,
        Remarks: $scope.ugradePassenger.upgradeRemarks,
      };

      if (report) {
        report.UpgradedPassengers.push(upgradedPassenger);
      } else {
        report =
          CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(
            flightId
          );
        report.UpgradedPassengers.push(upgradedPassenger);
        report.Status = "draft";
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
      }

      CabinReportLocalEditFactory.setCabinReportToStorage(report);
      $scope.passenger.UpgradedToSeat = upgradedPassenger;
      $scope.ugradePassenger.showSuccess = true;
      $scope.ugradePassenger.successMessage = "Upgrade submitted successfully!";
      $timeout(function () {
        $scope.ugradePassenger.showSuccess = false;
      }, 3500);
    }

    /**
     * Fills up the linked Passengers list.
     * @memberof PassengerCtrl
     */
    function getlinkedPassengers() {
      if (paxInfo && passenger.UCI) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (
              passenger.LinkedPassengers &&
              passenger.LinkedPassengers.includes(
                paxInfo.Seatmap[i].Columns[j].UCI
              )
            ) {
              $scope.linkedPassengersGroup.push(
                paxInfo.Seatmap[i].Columns[j].SeatNo
              );
            }
            if (
              passenger.LinkedPassengersWithProductId &&
              passenger.LinkedPassengersWithProductId.includes(
                paxInfo.Seatmap[i].Columns[j].ProductId
              )
            ) {
              $scope.linkedPassengersGroup.push(
                paxInfo.Seatmap[i].Columns[j].SeatNo
              );
            }
          }
        }
      }
    }

    /**
     * Removes upgrade from report
     * @memberof PassengerCtrl
     */
    function undo() {
      if (report) {
        report.UpgradedPassengers = report.UpgradedPassengers.filter(function (
          p
        ) {
          return p.OriginalSeatNo != passenger.SeatNo && p.UCI != passenger.UCI;
        });

        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
        CabinReportLocalEditFactory.setCabinReportToStorage(report);
      }
      $scope.passenger.UpgradedToSeat = false;
      $scope.ugradePassenger.showSuccess = true;
      $scope.ugradePassenger.successMessage = "Upgrade removed successfuly!";
      $timeout(function () {
        $scope.ugradePassenger.showSuccess = false;
      }, 3500);
      $scope.ugradePassenger.showUpgradeInput = false;
    }

    /**
     * Checks if the seat is available and fires warnings or errors
     * @memberof PassengerCtrl
     * @param {string} seat The seat number
     * @return {boolean} isSeatAvailableForUpgrate
     */
    function isSeatAvailableForUpgrate() {
      $scope.ugradePassenger.upgradedSeatNo =
        $scope.ugradePassenger.upgradedSeatNo.toUpperCase();
      formatSeatInput();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (
              paxInfo.Seatmap[i].Columns[j].SeatNo ==
              $scope.ugradePassenger.upgradedSeatNo
            ) {
              if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
                return true;
              }
              $scope.ugradePassenger.showUpgradeWarning = true;
              return false;
            }
          }
        }
      }

      //not found in seatmap
      $scope.showSeatChangeError = true;
      $scope.ugradePassenger.upgradedSeatNo = "";
      return false;
    }

    // Seat Change
    /**
     * Checks if the seat is available and fires warnings or errors
     * @memberof PassengerCtrl
     * @param {string} seat The seat number
     * @return {boolean} isSeatAvailableForChange
     */
    function isSeatAvailableForChange() {
      /** fix any input into 000A format */
      var missingZeroes = 4 - $scope.changeSeatFormData.changedSeatNo.length;
      for (var i = 0; i < missingZeroes; i++)
        $scope.changeSeatFormData.changedSeatNo =
          "0" + $scope.changeSeatFormData.changedSeatNo;
      $scope.changeSeatFormData.changedSeatNo =
        $scope.changeSeatFormData.changedSeatNo.toUpperCase();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (
              paxInfo.Seatmap[i].Columns[j].SeatNo ==
              $scope.changeSeatFormData.changedSeatNo
            ) {
              if (
                paxInfo.Seatmap[i].Columns[j].IsEmptySeat &&
                !IsAlreadyGivenSeat($scope.changeSeatFormData.changedSeatNo)
              ) {
                return true;
              } else {
                $scope.showSeatChangeWarning = true;
                return false;
              }
            }
          }
        }
      }
      //not found in seatmap
      $scope.showSeatChangeError = true;
      $timeout(function () {
        $scope.showSeatChangeError = false;
        $scope.changeSeatFormData.changedSeatNo = "";
      }, 3500);
      return false;
    }

    function IsAlreadyGivenSeat(newSeatNo) {
      return report.ChangedSeats.some(function (item) {
        return item.NewSeatNo == newSeatNo;
      });
    }

    /**
     * Gets called when user hits submit. Checks input then saves it
     * @memberof PassengerCtrl
     */
    function submitSeatChange() {
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;
      if (!isSeatAvailableForChange()) {
        return;
      }
      saveSeatChange();
    }

    function closeChangeWarning() {
      $scope.changeSeatFormData.showSeatChangeInput =
        !$scope.changeSeatFormData.showSeatChangeInput;
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;
    }

    /**
     * Gets called when input is ready
     * @memberof PassengerCtrl
     */
    function saveSeatChange() {
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;
      updateReportForSeatChange();
    }

    /**
     * Puts the new seat change in the report
     * @memberof PassengerCtrl
     */
    function updateReportForSeatChange() {
      var changedSeat = {
        Name: $scope.passenger.Fullname,
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        OriginalSeatNo: $scope.passenger.SeatNo,
        NewSeatNo: $scope.changeSeatFormData.changedSeatNo,
        Remarks: $scope.changeSeatFormData.seatChangeRemarks,
      };

      if (report) {
        report.ChangedSeats.push(changedSeat);
      } else {
        report =
          CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(
            flightId
          );
        report.ChangedSeats.push(changedSeat);
        report.Status = "draft";
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
      }

      CabinReportLocalEditFactory.setCabinReportToStorage(report);
      $scope.passenger.ChangedSeat = changedSeat;
      $scope.passenger.IsSeatChanged = true;
      $scope.showSeatChangeSuccess = true;
      $scope.successSeatChangeMessage = "Seat change submitted successfully!";
      $timeout(function () {
        $scope.showSeatChangeSuccess = false;
      }, 3500);
    }

    /**
     * Removes seat change from report
     * @memberof PassengerCtrl
     */
    function undoSeatChange() {
      if (report) {
        report.ChangedSeats = report.ChangedSeats.filter(function (p) {
          return p.OriginalSeatNo != passenger.SeatNo && p.UCI != passenger.UCI;
        });

        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
        CabinReportLocalEditFactory.setCabinReportToStorage(report);
      }
      $scope.passenger.ChangedSeat = null; // ?
      $scope.passenger.IsSeatChanged = false;
      $scope.showSeatChangeSuccess = true;
      $scope.successSeatChangeMessage = "Seat change removed successfuly!";
      $scope.changeSeatFormData.showSeatChangeInput = false;
      $timeout(function () {
        $scope.showSeatChangeSuccess = false;
      }, 3500);
    }

    /**
     * Checks if the data are new
     * @memberof PassengerCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */
    function IsOld(time) {
      IsOld = false;
      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();
        if (diff > 3600000) {
          IsOld = true;
        }
      }
      return IsOld;
    }

    /**
     * Add or remove passenger from the Cabin Luggage Compliance Report
     * */
    function updateCabinLuggageReport() {
      var cabinLuggageReport = {
        isChecked: $scope.passenger.luggageCompliance.hasTwoLuggage,
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        FlightId: $scope.flight.FlightId,
        FareFamily: $scope.passenger.FareFamily,
        IsFlightCompliant: false,
        Created: moment(),
      };

      LuggageComplianceFactory.setLuggageComplianceToStorage(
        cabinLuggageReport
      );
    }

    /**
     * Close the modal
     * @memberof PassengerCtrl
     */
    function closeModal() {
      $uibModalInstance.dismiss("");
    }

    /**
     * Close the modal
     * @memberof PassengerCtrl
     */
    function submitCampaignFeedback() {
      $scope.passenger.Campaign.assignment.Status =
        +$scope.passenger.Campaign.assignment.StatusStr;
      CampaignFactory.updateCampaignPassenger(
        +flightId,
        $scope.passenger.Campaign.assignment
      );
      $scope.isFeedbackUpdated = true;
      $timeout(function () {
        $scope.isFeedbackUpdated = false;
      }, 3500);
    }

    /**
     * Manages OneStopShop tab visibility
     * Gets called if there are OneStopShop treatments available for this passenger
     */
    function treatmentAvailability(counter) {
      if (user.position == "SA") {
        $scope.ossCounter = counter;
        $scope.showOneStopShop = true;
      }
    }

    /**
     * Manages ShopInTheCloud tab visibility
     * Gets called if there are orders available for this passenger and also checks if a pending report exists
     */
    function orderAvailability(counter) {
      if (!counter) {
        counter = 0;
      }
      var isShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
      if (
        isShopInTheCloudEnable &&
        flight.LineStatus != "na" &&
        flight.LineStatus != "stored"
      ) {
        $scope.ordersCounter = counter;
        $scope.showShopInTheCloudTab = true;
      }
    }

    /**
     * Retrieve wifi vouchers
     * @memberof PassengerCtrl
     */
    function retrieveWifiVouchers(pnr) {
      $scope.showPanel = "loading";

      var RequestWifiVouchers = {
        PNR: pnr,
        FlightId: $scope.flight.FlightId,
        FlightDate: passenger.STDLocal,
      };

      WifiVouchersFactory.retrieveWifiVouchers(RequestWifiVouchers).then(
        (res) => retrieveHandleSubmitResponse(res)
      );
    }

    function retrieveHandleSubmitResponse(res) {
      $scope.newVoucherCode = false;
      handleSubmitResponse(res);
    }

    /**
     * Create wifi voucher - "Text and surf"
     * @memberof PassengerCtrl
     */
    function createTextVoucher() {
      $scope.showPanel = "loading";
      var RequestCreateVoucher = {
        PNR: passenger.PNR,
        FlightId: $scope.flight.FlightId,
        FlightNumber: $scope.flight.FlightNo,
        FullName: passenger.Fullname,
        PlanId: "2902",
        FlightDate: passenger.STDLocal,
      };
      WifiVouchersFactory.createWifiVoucher(RequestCreateVoucher).then((res) =>
        createHandleSubmitResponse(res)
      );
    }

    /**
     * Create wifi voucher - "Stream"
     * @memberof PassengerCtrl
     */
    function createStreamVoucher(params) {
      $scope.showPanel = "loading";
      var RequestCreateVoucher = {
        PNR: passenger.PNR,
        FlightId: $scope.flight.FlightId,
        FlightNumber: $scope.flight.FlightNo,
        FullName: passenger.Fullname,
        PlanId: "2904",
        FlightDate: passenger.STDLocal,
      };
      WifiVouchersFactory.createWifiVoucher(RequestCreateVoucher).then((res) =>
        createHandleSubmitResponse(res)
      );
    }

    function createHandleSubmitResponse(res) {
      $scope.newVoucherCode = true;
      handleSubmitResponse(res);
    }

    function handleSubmitResponse(res) {
      if (res.success) {
        if ($scope.newVoucherCode == false) {
          $scope.textAndSurfCodes = [];
          $scope.streamCodes = [];
          $scope.newVouchers = [];
        } else {
          $scope.newVouchers = res.data;
        }
        $scope.notRetrieved = false;
        manageResponseMessage("success", res.message);
        $scope.wifiVouchersCodes = res.data;

        $scope.wifiVouchersCodes.forEach(function (code) {
          if (code.Type == "Text & Surf") {
            $scope.textAndSurfCodes.push(code.VoucherCode);
          }
        });

        $scope.wifiVouchersCodes.forEach(function (code) {
          if (code.Type == "Stream") {
            $scope.streamCodes.push(code.VoucherCode);
          }
        });
      } else {
        $scope.newVoucherCode = false;
        manageResponseMessage("failure", res.message);
      }
    }

    /**
     * Manage message alerts
     * @param {string} panelToShow
     * @param {string} message
     */
    function manageResponseMessage(panelToShow, message) {
      $scope.submitMessage = message;
      $scope.showPanel = panelToShow;
    }

    /**
     * Initializes Passenger Connection Info using local misconnection data (per passenger).
     * It builds passenger.ConnectionLegs for the modal UI.
     */
    function initPassengerConnectionInfo() {
      try {
        if (!$scope.passenger || !$scope.passenger.UCI) {
          return;
        }
        var uci = $scope.passenger.UCI;

        var misconnectionFlightId = getMisconnectionFlightId();

        // 1) Get misconnection flights for this disrupted flight from local storage
        var misconnectionFlights =
          MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(
            misconnectionFlightId
          ) || [];

        if (!misconnectionFlights.length) {
          return;
        }

        // 2) Find FlightConnectionPassenger that matches this UCI
        var passengerConnection = null;

        misconnectionFlights.forEach(function (result) {
          if (result.Passengers && result.Passengers.length) {
            result.Passengers.forEach(function (passenger) {
              if (
                passenger.UCI === uci &&
                passenger.Actions &&
                passenger.Actions.length
              ) {
                // For now: first match wins
                passengerConnection = passenger;
              }
            });
          }
        });

        if (!passengerConnection) {
          return;
        }

        // 3) Build UI legs + showReprotection flag from passenger actions
        var connectionInfo = buildConnectionLegsFromActions(
          passengerConnection.Actions
        );

        if (
          connectionInfo &&
          connectionInfo.legs &&
          connectionInfo.legs.length
        ) {
          $scope.passenger.ConnectionLegs = connectionInfo.legs;
          $scope.passenger.ShowReprotection = connectionInfo.showReprotection;
        }
      } catch (e) {
        console.error("Error initializing Passenger Connection Info", e);
      }
    }

    function getMisconnectionFlightId() {
      // Use the original flightId as base
      var misconnectionFlightId = flightId;

      if (defaultCalendarDate && misconnectionFlightId === "1226541") {
        misconnectionFlightId = 2242084;
      }

      return misconnectionFlightId;
    }

    /**
     * Returns true if reprotection is considered "new" for UI,
     * following the same rule as PaxCtrl coloring:
     * - RED / ShowReprotection = reprotection decided within 60 minutes before STD
     */
    function isNewReprotection(action) {
    //  return true; //only for the tests
      if (
        !action ||
        !action.HasReprotectedAction ||
        !action.STD ||
        !action.ActionTimestamp
      ) {
        return false;
      }
      var std = new Date(flight.ScheduledDeparture);
      var ts = new Date(action.ActionTimestamp);

      if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
        // If dates are invalid, we do not treat it as a valid reprotection
        return false;
      }

      var diffMinutes = (std.getTime() - ts.getTime()) / 60000;

      // Same rule με PaxCtrl hasReprotection (RED):
      // "new" reprotection = from this point and closer than 60' to STD
      return diffMinutes <= 60;
    }

    /**
     * Builds an ordered list of connection legs (original + final reprotection).
     * Filters out late reprotections and maps actions into clean UI leg objects.
     * Returns only the missed flight (A) and the final valid journey (C).
     */
    function buildConnectionLegsFromActions(passengerActions) {
      if (!passengerActions || !passengerActions.length) {
        return { legs: [], showReprotection: false };
      }

      // 1) Order actions in journey order (A -> B -> C ...)
      var orderedActions = passengerActions.slice().sort(function (a, b) {
        return (a.FlightOccurrenceOrder || 0) - (b.FlightOccurrenceOrder || 0);
      });

      // 2) Original flight: first non-reprotected action, fallback = first
      var originalFlightAction =
        orderedActions.find(function (a) {
          return !a.HasReprotectedAction;
        }) || orderedActions[0];

      // 3) Valid reprotections: reprotected AND not "late"
      var validReprotectionActions = orderedActions.filter(function (action) {
        return isNewReprotection(action);
      });

      var hasValidReprotection = validReprotectionActions.length > 0;

      // ===== Case 1: there is a valid reprotection (A + final C journey) =====
      if (hasValidReprotection) {
        var latestWaveTimestamp = null;

        validReprotectionActions.forEach(function (action) {
          var ts = action.ActionTimestamp
            ? new Date(action.ActionTimestamp).getTime()
            : action.STD
            ? new Date(action.STD).getTime()
            : 0;

          if (latestWaveTimestamp === null || ts > latestWaveTimestamp) {
            latestWaveTimestamp = ts;
          }
        });

        // Final reprotection journey (C): only actions from the last wave
        var finalReprotectionActions = validReprotectionActions.filter(
          function (action) {
            var ts = action.ActionTimestamp
              ? new Date(action.ActionTimestamp).getTime()
              : action.STD
              ? new Date(action.STD).getTime()
              : 0;

            return ts === latestWaveTimestamp;
          }
        );

        // Sort final journey in correct leg order
        finalReprotectionActions.sort(function (l, r) {
          return (
            (l.FlightOccurrenceOrder || 0) - (r.FlightOccurrenceOrder || 0)
          );
        });

        // Avoid showing the same flight twice
        finalReprotectionActions = finalReprotectionActions.filter(function (
          action
        ) {
          return !isSameConnectionLeg(action, originalFlightAction);
        });

        var legsWithReprot = [];

        if (originalFlightAction) {
          legsWithReprot.push(
            mapActionToLeg(
              originalFlightAction,
              false, // isNewFlight
              true // isOriginalMissed
            )
          );
        }

        finalReprotectionActions.forEach(function (action) {
          legsWithReprot.push(
            mapActionToLeg(
              action,
              true, // isNewFlight
              false // isOriginalMissed
            )
          );
        });

        markNextDayFlags(legsWithReprot);

        return {
          legs: legsWithReprot,
          showReprotection: true,
        };
      }

      // ===== Case 2: no valid reprotection -> escort / normal connection =====

      var targetAction =
        orderedActions.find(function (a) {
          return a.FlightOccurrenceOrder === 1;
        }) ||
        orderedActions[1] ||
        orderedActions[0];

      var legsWithoutReprot = [];

      if (targetAction) {
        legsWithoutReprot.push(
          mapActionToLeg(
            targetAction,
            false, // isNewFlight
            false // isOriginalMissed
          )
        );
      }

      markNextDayFlags(legsWithoutReprot);

      return {
        legs: legsWithoutReprot,
        showReprotection: false,
      };
    }

    function isSameConnectionLeg(left, right) {
      if (!left || !right) {
        return false;
      }

      var sameFlightNo = left.FlightNumber === right.FlightNumber;
      var sameDep = left.Departure === right.Departure;
      var sameArr = left.Arrival === right.Arrival;

      var leftDate = left.FlightDate
        ? new Date(left.FlightDate).toDateString()
        : null;
      var rightDate = right.FlightDate
        ? new Date(right.FlightDate).toDateString()
        : null;
      var sameDate = !leftDate || !rightDate || leftDate === rightDate;

      return sameFlightNo && sameDep && sameArr && sameDate;
    }

    /**
     * Returns a Date stripped to year-month-day (no time component)
     */
    function getDateOnly(dateValue) {
      var d = new Date(dateValue);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    /**
     * Sets isNextDay = true for legs that depart on the next calendar day
     * compared to the first leg in the list.
     */
    function markNextDayFlags(legs) {
      if (!legs || !legs.length || !legs[0].stdLocal) {
        return;
      }

      var baseDepartureDate = getDateOnly(legs[0].stdLocal);

      legs.forEach(function (leg, index) {
        // First leg or missing date -> never marked as next day
        if (!leg.stdLocal || index === 0) {
          leg.isNextDay = false;
          return;
        }

        var legDepartureDate = getDateOnly(leg.stdLocal);
        leg.isNextDay = legDepartureDate > baseDepartureDate;
      });
    }

    /**
     * Maps a misconnection action to a UI leg for Passenger Connection Info.
     * @param {Object} action - raw action from backend
     * @param {boolean} isNewFlight - true if this leg belongs to the final reprotected journey (C)
     * @param {boolean} isOriginalMissed - true if this leg is the original missed flight (A)
     */
    function mapActionToLeg(action, isNewFlight, isOriginalMissed) {
      var stdLocal = action.STD_Local || action.STD || null;
      var stdUtc = action.STD || null;

      var etdLocal = action.ETD_Local || null;
      var etdUtc = action.ETD || null;

      var atdLocal = action.ATD_Local || null;
      var atdUtc = action.ATD || null;

      // Decide which time is considered "primary" for bold display:
      // - ETD if available
      // - otherwise STD
      var hasEtd = !!(etdLocal || etdUtc);
      var primaryTimeType = hasEtd ? "ETD" : "STD";

      return {
        // journey flags
        isNewFlight: !!isNewFlight, // final reprotection leg (C)
        isOriginalMissed: !!isOriginalMissed, // original missed leg (A)

        hasReprotection: !!action.HasReprotectedAction,
        hasEscort: !!action.HasEscortAction,
        order: action.FlightOccurrenceOrder || 0,

        flightNo: action.FlightNumber,
        departure: action.Departure,
        arrival: action.Arrival,

        // STD
        stdLocal: stdLocal,
        stdUtc: stdUtc,

        // ETD
        etdLocal: etdLocal,
        etdUtc: etdUtc,

        // ATD
        atdLocal: atdLocal,
        atdUtc: atdUtc,

        departureGate: action.Dep_Gate,

        primaryTimeType: primaryTimeType,
      };
    }

    /**
     * Returns true if STD should be highlighted as primary time for this leg.
     */
    $scope.isStdHighlighted = function (leg) {
      if (!leg) {
        return false;
      }
      // We highlight STD when it is the primary time type
      return leg.primaryTimeType === "STD";
    };
  }
})();
